import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  Grid, Card, MenuItem, Select,Button, TextField
} from "@mui/material";
import dayjs from "dayjs";
import { useGetAllInvoiceQuery, useGetDriverQuery } from "../../../Api/attoDeskApi";
import { useStyles } from "../../../theme/appStyles";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import {
  ProductType,
  TransferType,
  WorkOrderStatus,
} from "../../../Core/Enum/enum";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import {
  ICompanyDetails,
  ICustomer,
  IProductPopUP,
  ITaxes,
  IEmailTemplate,
  IDriver,
  IAssignDrivers,
} from "../../../Api/Interface/api.interface";
import {
useGetEmailTemplateQuery,
} from "../../../Api/attoDeskApi";
import axios from "axios";
import { useNotifier } from "../../../Core/Notifier";
import DownloadIcon from '@mui/icons-material/Download';
import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";

interface Trip {
  quoteWorkOrderNo: string;
  productName: string;
  departureDateTime: string;
  returnDateTime: string;
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  departureAddress: string;
  destinationAddress: string;
  InvoiceNo: string;
}

interface DriverTripData {
  driverId: string;
  driverName: string;
  driverEmail: string; // New field for email
  trips: Trip[];
}



const DriverTripsComponent: React.FC = () => {
  // Fetch invoice data using your API hook
  const { data: invoiceData, isLoading, isError } = useGetAllInvoiceQuery({
    searchText: "",
    id: "",
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });
  const classes = useStyles();
    const componentRef = useRef<HTMLDivElement>(null);

  const [driverTripsList, setDriverTripsList] = useState<DriverTripData[]>([]);
  const [selectedTrips, setSelectedTrips] = useState<{ [key: string]: boolean }>({});
  const theme = useTheme();
  const [currentSearchQueryEmailTemplate, setCurrentSearchQueryEmailTemplate] =useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const { showErrorMessage, showMessage } = useNotifier();
  const [drivers, setDrivers] = useState<any[]>([]);
  const { data: driverData } = useGetDriverQuery({ searchText: "", id: "" });
  const [loading, setLoading] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState<string>("");
    const [dateFilter, setDateFilter] = useState<string>("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

       const {
            data: emailTemplateData,
            isLoading: emailTemplateIsLoading,
            isError: emailTemplateError,
            refetch: emailTemplateRefetch,
          } = useGetEmailTemplateQuery({
            searchText: currentSearchQueryEmailTemplate,
            // id: "",
          });
          
    const emailTemplateList: IEmailTemplate[] = useMemo(() => {
      if (emailTemplateData && Array.isArray(emailTemplateData.data)) {
        return emailTemplateData.data as IEmailTemplate[];
      }
      return [];
    }, [emailTemplateData]);

  useEffect(() => {
    if (!invoiceData || !Array.isArray(invoiceData.data)) return;

    const invoices = invoiceData.data;
    const driverTripsMap: { [key: string]: Trip[] } = {};
    const driverNamesMap: { [key: string]: string } = {};
    const driverEmailsMap: { [key: string]: string } = {};

    invoices.forEach((invoice: any) => {
      if (Array.isArray(invoice.drivers) && Array.isArray(invoice.quoteWorkOrderSale)) {
        invoice.drivers.forEach((driver: any) => {
          const key = driver.id.toString();
          driverNamesMap[key] = `${driver.driverFirstName} ${driver.driverLastName}`;
          // Assume driver.email or similar field exists; if not, use a placeholder
          driverEmailsMap[key] = driver.driverEmail || "unknown@example.com";

          invoice.quoteWorkOrderSale.forEach((sale: any) => {
            const trip: Trip = {
              quoteWorkOrderNo: invoice.quoteWorkOrderNo,
              productName: sale.productName,
              departureDateTime: sale.departureDateTime,
              returnDateTime: sale.returnDateTime,
              transferType: sale.transferType,
              transferTypeFrom: sale.transferTypeFrom,
              transferTypeTo: sale.transferTypeTo,
              departureAddress: sale.departureAddress,
              destinationAddress: sale.destinationAddress,
              InvoiceNo: invoice.InvoiceNo,
            };

            if (driverTripsMap[key]) {
              driverTripsMap[key].push(trip);
            } else {
              driverTripsMap[key] = [trip];
            }
          });
        });
      }
    });

    // Convert the map to an array of driver trip data
    const groupedDrivers: DriverTripData[] = Object.keys(driverTripsMap).map((driverId) => ({
      driverId,
      driverName: driverNamesMap[driverId] || "Unknown",
      driverEmail: driverEmailsMap[driverId] || "unknown@example.com",
      trips: driverTripsMap[driverId],
    }));

    setDriverTripsList(groupedDrivers);
  }, [invoiceData]);

  const getFilteredDriverTrips = () => {
  return driverTripsList
    .filter(driver => !selectedDriver || driver.driverId === selectedDriver)
    .map(driver => ({
      ...driver,
      trips: driver.trips.filter(trip => {
        if (!dateFilter || dateFilter === "") return true;

        const tripDate = dayjs(trip.departureDateTime);
        switch (dateFilter) {
          case "today":
            return tripDate.isSame(dayjs(), "day");
          case "yesterday":
            return tripDate.isSame(dayjs().subtract(1, "day"), "day");
          case "this_week":
            return tripDate.isSame(dayjs(), "week");
          case "last_week":
            return tripDate.isSame(dayjs().subtract(1, "week"), "week");
          case "this_month":
            return tripDate.isSame(dayjs(), "month");
          case "last_month":
            return tripDate.isSame(dayjs().subtract(1, "month"), "month");
          case "custom":
            return tripDate.isBetween(dayjs(startDate), dayjs(endDate), null, "[]");
          default:
            return true;
        }
      }),
    }))
    .filter(driver => driver.trips.length > 0);
};

const filteredDriverTrips = useMemo(() => getFilteredDriverTrips(), [
  driverTripsList,
  selectedDriver,
  dateFilter,
  startDate,
  endDate,
]);


   useEffect(() => {
      if (driverData && Array.isArray(driverData.data)) {
        const filteredDrivers = driverData.data.filter((driver: any) => driver.driverUserRole === 'driver');
        setDrivers(filteredDrivers);
      }
    }, [driverData]);


    const capitalize = (str: string | null | undefined): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

  if (isLoading) return <CircularProgress />;
  if (isError)
    return (
      <Typography variant="h6" color="error">
        Error loading driver trip details.
      </Typography>
    );

    const handleTripCheckboxChange = (tripKey: string) => {
      setSelectedTrips((prev) => ({
        ...prev,
        [tripKey]: !prev[tripKey],
      }));
    };

    const handleSelectAllForDriver = (driverId: string | number, trips: Trip[]) => {
      const allSelected = trips.every((trip, idx) => {
        const tripKey = `${driverId}-${trip.quoteWorkOrderNo}-${trip.productName}-${idx}`;
        return selectedTrips[tripKey];
      });
    
      const updatedSelections = { ...selectedTrips };
    
      trips.forEach((trip, idx) => {
        const tripKey = `${driverId}-${trip.quoteWorkOrderNo}-${trip.productName}-${idx}`;
        updatedSelections[tripKey] = !allSelected; // Toggle all to selected or unselected
      });
    
      setSelectedTrips(updatedSelections);
    };
    
  
   // Assume emailTemplateList is available in your component’s scope
// For example, imported from a context or passed as a prop.

const sendEmailForDriver = async (driver: DriverTripData) => {
  setLoading(true);
  // Filter selected trips for this driver using a unique key (e.g., `${driverId}-${quoteWorkOrderNo}-${productName}-${idx}`)
  const tripsForDriver = driver.trips.filter((trip, idx) => {
    const tripKey = `${driver.driverId}-${trip.quoteWorkOrderNo}-${trip.productName}-${idx}`;
    return selectedTrips[tripKey];
  });

  if (tripsForDriver.length === 0) {
    alert(`No trips selected for ${driver.driverName}`);
    return;
  }

  // Find the "Trip Assignment" template
  const defaultTemplate = emailTemplateList.find(
    (template) => template.template_name === "Trip Assignment"
  );
  if (!defaultTemplate) {
    alert("Trip Assignment email template not found");
    return;
  }

  const headerContent = `<p>Dear ${driver.driverName},</p>
<p>You have been assigned a new trip. Please find the details below:</p>`;
    const footerContent =`<p>For further assistance, please feel free to contact us.</p>
<p>
  Best regards,<br />
  TJ bus<br />
  11, Benleigh drive, Scarborough, ON, M1H 1J1.<br />
  647 710-0532 | tjbusline@gmail.com.
</p>`;
  
    // Build trip details for each selected trip
    const tripDetailsArray = tripsForDriver.map((trip) => {
      const busType = trip.productName; // Using productName as bus type
      const transferType = (Object.keys(TransferType) as (keyof typeof TransferType)[])
      .find((key) => TransferType[key] === String(trip.transferType))|| "";
      const transferFrom = trip.transferTypeFrom || "";
      const transferTo = trip.transferTypeTo || "";
      const departureAddress = trip.departureAddress || "";
      const departureDate = dayjs(trip.departureDateTime).isValid()
        ? dayjs(trip.departureDateTime).format("DD-MMM-YY hh:mm A")
        : trip.departureDateTime || "";
      const destinationAddress = trip.destinationAddress || "";
      const destinationDate =
        trip.returnDateTime && dayjs(trip.returnDateTime).isValid()
          ? dayjs(trip.returnDateTime).format("DD-MMM-YY hh:mm A")
          : "";
  
          return `<p>
          <strong>Bus:</strong> ${busType}<br /><br />
          ${transferType} (${transferFrom} to ${transferTo})<br /><br />
          <strong>𝗗eparture:</strong> ${departureAddress} (${departureDate})<br /><br />
          <strong>𝗗estination:</strong> ${destinationAddress}${destinationDate ? ` (${destinationDate})` : ""}
        </p>`;
        

      });
    
  
    // Combine all trip details with a divider
    const tripDetailsContent = tripDetailsArray.join("\n\n---------------------\n\n");
  
    // Create the final email content with one header, all trip details, and one footer
    const emailContent = headerContent + tripDetailsContent + footerContent;

  const formData = {
    to: driver.driverEmail, // Ensure your driver object includes an email field
    subject: defaultTemplate.subject,
    message: emailContent,
  };

  // Set the headers with your auth token
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  };

  try {
    const emailResponse =  await axios.post(`${API_URL}/send-email`, formData, { headers });
    if (emailResponse.status === 200) {
      showMessage(`Email sent successfully`);
      setSelectedTrips({});
   // alert(`Email sent to ${driver.driverEmail} with ${tripsForDriver.length} trip(s).`);
      }
  } catch (error) {
    showErrorMessage("Failed to send email.");

  }
  setLoading(false);
};

    const handleDriverChange = (event: any) => {
      const selectedDriver = event.target.value;
       setSelectedDriver(String(selectedDriver)); // Update state with the selected driver
    
    };

const handleDownloadPDF = () => {
  const filteredDrivers = getFilteredDriverTrips();

  // Option 1: If you want to reuse the same table, hide unfiltered rows using "no-pdf"
  // Option 2: Better: render a temporary hidden table with only filteredDrivers
  const element = componentRef.current; 

  const opt = {
    margin: 0.5,
    filename: "tjbus_invoices.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      ignoreElements: (el: Element) => el.classList.contains("no-pdf"),
    },
    jsPDF: {
      unit: "in",
      format: "a4",
      orientation: "landscape",
    },
  };

  html2pdf().set(opt).from(element).save();
};


const handleExportToExcel = () => {
  const filteredDrivers = getFilteredDriverTrips();

  const data = filteredDrivers.flatMap(driver =>
    driver.trips.map(trip => ({
      Driver: driver.driverName,
      InvoiceNo: trip.InvoiceNo,
      Bus: trip.productName,
      TransferType: trip.transferType
        ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
            .find(key => TransferType[key] === String(trip.transferType))
        : "",
      TransferInfo: trip.transferTypeFrom && trip.transferTypeTo
        ? `${trip.transferTypeFrom} to ${trip.transferTypeTo}`
        : "N/A",
      Departure: trip.departureAddress,
      DepartureTime: dayjs(trip.departureDateTime).format("DD-MMM-YY hh:mm A"),
      Destination: trip.destinationAddress,
      ReturnTime: trip.returnDateTime
        ? dayjs(trip.returnDateTime).format("DD-MMM-YY hh:mm A")
        : "",
    }))
  );

 

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Trips");
  XLSX.writeFile(workbook, "driver_trips.xlsx");
};


  return (
    // <Box p={3} sx={{ backgroundColor: "#f0f2f5" }}>
    //   <Typography variant="h4" align="center" gutterBottom>
    //     Driver Trip Details
    //   </Typography>
    <div ref={componentRef} >

 

  <Grid container spacing={3}>


    <Grid item xs={12}>
       <Card className={classes.card}>
         <Box mb={2} padding={2}>


           <Grid container spacing={2} className="no-pdf">
             {/* Select Driver */}
             <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Driver
               </Typography>
               <Select
                 className={classes.textField}
                 value={selectedDriver}
                 onChange={handleDriverChange}
                 displayEmpty
                 
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">All Drivers</MenuItem>
                 {drivers.map((driver: any) => (
                   <MenuItem key={driver.id} value={driver.id}>
                     {`${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)}`}
                   </MenuItem>
                 ))}
               </Select>
             </Grid>







    <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Date
               </Typography>
               <Select
                 className={classes.textField}
                 value={dateFilter}
                 onChange={(e) => setDateFilter(e.target.value)}
                 displayEmpty
                
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">Select date filter</MenuItem>
                 <MenuItem value="today">Today</MenuItem>
                 <MenuItem value="yesterday">Yesterday</MenuItem>
                 <MenuItem value="this_week">This Week</MenuItem>
                 <MenuItem value="last_week">Last Week</MenuItem>
                 <MenuItem value="this_month">This Month</MenuItem>
                 <MenuItem value="last_month">Last Month</MenuItem>
                 <MenuItem value="custom">Custom</MenuItem>
               </Select>
             </Grid>
 
             {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
             {dateFilter === "custom" && (
               <>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     Start Date
                   </Typography>
                   <TextField
                   variant="outlined"
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={startDate}
                     onChange={(e) => setStartDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
                     
                   />
                 </Grid>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     End Date
                   </Typography>
                   <TextField
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={endDate}
                     onChange={(e) => setEndDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
              
                   />
                 </Grid>
               </>
             )}

 
         
           </Grid>
         </Box>
       </Card>
     </Grid>





            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Tour List
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
          {driverTripsList.length > 0 && (   
            
            

  <>
  <Grid item className="no-pdf" sx={{ '@media print': {
    display: 'none',
  } }}>
    
        <Button
          variant="contained"
          startIcon={<DownloadIcon  />}
          className={classes.addButton}
            onClick={handleDownloadPDF}
        >
          PDF
        </Button>
      
     
  </Grid>

  <Grid item className="no-pdf" sx={{ '@media print': {
    display: 'none',
  } }}>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />} // You can use any icon you like
          className={classes.addButton}
          onClick={handleExportToExcel}
        >
          Excel
        </Button>
      </Grid>



      </>



          )}
                            </Grid>
                          </Grid>
                        </Grid>
                        </Card>

              </Grid>




{filteredDriverTrips.map((driver) => (
<Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                            {driver.driverName}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              

                              <Grid item className="no-pdf">
                              <Button
      disabled={loading}
      variant="contained"
      size="small"
      className={classes.addButton}
      startIcon={<EmailIcon />}
      onClick={() => sendEmailForDriver(driver)}
      sx={{
        visibility: driver.trips.some((trip, idx) => {
          const tripKey = `${driver.driverId}-${trip.quoteWorkOrderNo}-${trip.productName}-${idx}`;
          return selectedTrips[tripKey];
        }) ? "visible" : "hidden", // Preserves space but hides button when not needed
      }}
    >
      {loading ? <CircularProgress size={24} /> : "Send Email"}
    </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid>
                      
                          <TableContainer>
                            <Table sx={{
              width: "100%",
              marginBottom: "1.5rem",
              verticalAlign: "top",
              "& > :not(caption) > * > *": {
                padding: "6px", // Ensure custom padding is applied
              },
             
            }}>
                              <TableHead className={classes.tableHeaderRow}>
                                <TableRow>
                                <TableCell className={`${classes.tablheader} no-pdf`}>
                <CustomCheckbox
          name="selectAll"
          checked={driver.trips.every((trip, idx) => selectedTrips[`${driver.driverId}-${trip.quoteWorkOrderNo}-${trip.productName}-${idx}`])}
          onChange={() => handleSelectAllForDriver(driver.driverId, driver.trips)}
        />
                  </TableCell> 
                   <TableCell  className={classes.tablCell} sx={{ fontWeight: "bold" }}>Invoice No</TableCell> 
                  <TableCell   className={classes.tablCell}sx={{ fontWeight: "bold" }}>Bus</TableCell> 
                   <TableCell  className={classes.tablCell} sx={{ fontWeight: "bold" }}>Transfer Type</TableCell>
                  <TableCell  className={classes.tablCell} sx={{ fontWeight: "bold" }}>Transfer Info</TableCell>
                  <TableCell  className={classes.tablCell}  sx={{ fontWeight: "bold" }}>Departure</TableCell>
                  <TableCell   className={classes.tablCell} sx={{ fontWeight: "bold" }}>Destination</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                             
                              {driver.trips.map((trip, idx) => {
                  const tripKey = `${driver.driverId}-${trip.quoteWorkOrderNo}-${trip.productName}-${idx}`;
                  return (
                  <TableRow key={tripKey} className={classes.tableRowHover}>
                     <TableCell  className={`${classes.tablCell} no-pdf`}>
                            <CustomCheckbox name="checkbox" checked={!!selectedTrips[tripKey]}
                          onChange={() => handleTripCheckboxChange(tripKey)} />
                          </TableCell> 
                          <TableCell  component="th"  scope="row"  sx={{ whiteSpace: "nowrap"}}  className={classes.tablCell}>{trip.InvoiceNo}</TableCell>
                          <TableCell  component="th"  scope="row"  className={classes.tablCell}>{trip.productName}</TableCell>
                   
                    <TableCell  component="th"  scope="row"  className={classes.tablCell}>
                        {trip.transferType
                        ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
                         .find((key) => TransferType[key] === String(trip.transferType))
                          : ""}</TableCell> 
                    <TableCell  component="th"  scope="row"  className={classes.tablCell}>
                      {trip.transferTypeFrom && trip.transferTypeTo
                        ? `${trip.transferTypeFrom} to ${trip.transferTypeTo}`
                        : "N/A"}
                    </TableCell>
                    <TableCell  component="th"  scope="row"   className={classes.tablCell}>
                      {trip.departureAddress && trip.departureDateTime ? (
                        <>
                          <Typography variant="body2">
                            {trip.departureAddress}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {dayjs(trip.departureDateTime).isValid()
                              ? dayjs(trip.departureDateTime).format("DD-MMM-YY hh:mm A")
                              : trip.departureDateTime}
                          </Typography>
                        </>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                    <TableCell  component="th"  scope="row"  className={classes.tablCell}>
                      {trip.destinationAddress ? (
                        <>
                          <Typography variant="body2">
                            {trip.destinationAddress}
                          </Typography>
                          {trip.returnDateTime && dayjs(trip.returnDateTime).isValid() && (
                            <Typography variant="caption" color="textSecondary">
                              {dayjs(trip.returnDateTime).format("DD-MMM-YY hh:mm A")}
                            </Typography>
                          )}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  </TableRow>
                   );
                  })}
                               
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Card>
                    </Grid>

))}

</Grid>
</Grid>
</Grid>

{driverTripsList.length === 0 && (
  <Box mt={4} textAlign="center">
    <p>
      No tour list available
    </p>
  </Box>
)}
      </div>
    // </Box>

  );
};

export default DriverTripsComponent;
